import { Button, Card, CardContent, Grid } from "@mui/material";
import { ConfirmDangerModalComponent, IDType, TaxType } from "@soqs/common";
import React, { useMemo, useState } from "react";
import { Form, FormSpy } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import { config } from "../config";
import arrayMutators from "final-form-arrays";
import {
  currentPage,
  formState,
  setPage,
  updateFormState,
  submitFormAsync,
  trusttype,
} from "../features/AppSlice";
import TrustDetails from "./EnterDetailsComponents/TrustDetails";
import RequestorDetails from "./EnterDetailsComponents/RequestorDetails";
import TrustAdditionalDetailsIndividuals from "./EnterDetailsComponents/TrustAdditionalDetailsIndividuals";
import TrustAdditionalDetailsEntities from "./EnterDetailsComponents/TrustAdditionalDetailsEntities";

const EnterDetails = () => {
  const trustType = useSelector(trusttype);
  const dispatch = useDispatch();
  const wizardPage = useSelector(currentPage);
  const setWizardPage = (newPage) => {
    dispatch(setPage(newPage));
  };

  const [confirmClearModal, setConfirmClearModal] = useState(false);

  const initV = {
    //Form Defaults
    bo_individuals: [],
    bo_entities: [],
    bo_entity_representatives: [],
    idtype: IDType.RSA_Id,
    taxtype: TaxType.PIT,
    // bo_individuals: [
    //   {
    //     //bo_individual_key: 1738931403696,
    //     bo_individual_sorted: false,
    //     bo_individual_collapsed: false,
    //     bo_individual_botype: 1,
    //     bo_individual_idtype: "1",
    //     bo_individual_taxtype: 1,
    //     bo_individual_country: "ZAF",
    //     bo_individual_mobilecode: "27",
    //     bo_individual_passportcountry: "ZAF",
    //     bo_individual_placeofbirth: "ZAF",
    //     bo_individual_taxjuristiction: "ZAF",
    //     bo_individual_passportdt: "2010/01/01",
    //     bo_individual_name: "Test",
    //     bo_individual_surname: "TestSurname",
    //     bo_individual_email: "Test.TestSurname@gmail.com",
    //     bo_individual_streetname: "5 Test Street",
    //     bo_individual_city: "PRETORIA",
    //     bo_individual_postalcode: "0010",
    //     bo_individual_idnumber: "6311135058084",
    //     bo_individual_taxnumber: "1327118830",
    //     bo_individual_mobile: "0725555555",
    //     bo_individual_suburb: "PRETORIA",
    //   },
    // ],
    // bo_entities: [
    //   {
    //     bo_entity: 1738931495694,
    //     bo_entity_representatives: [
    //       {
    //         bo_entity_representative: 1738931516683,
    //         bo_entity_representative_sorted: false,
    //         bo_entity_representative_collapsed: false,
    //         bo_entity_representative_botype: 1,
    //         bo_entity_representative_idtype: "1",
    //         bo_entity_representative_taxtype: 1,
    //         bo_entity_representative_country: "ZAF",
    //         bo_entity_representative_mobilecode: "257",
    //         bo_entity_representative_passportcountry: "ZAF",
    //         bo_entity_representative_placeofbirth: "ZAF",
    //         bo_entity_representative_taxjuristiction: "ZAF",
    //         bo_entity_representative_name: "Test",
    //         bo_entity_representative_surname: "TestSurname",
    //         bo_entity_representative_taxnumber: "1327118830",
    //         bo_entity_representative_idnumber: "6311135058084",
    //         bo_entity_representative_mobile: "0725555555",
    //         bo_entity_representative_email: "test@gmail.com",
    //         bo_entity_representative_streetname: "dddd",
    //         bo_entity_representative_suburb: "PRETORIA",
    //         bo_entity_representative_city: "PRETORIA",
    //         bo_entity_representative_postalcode: "0181",
    //       },
    //     ],
    //     bo_entity_type: "4",
    //     bo_entity_taxnumber: "1327118830",
    //     bo_entity_taxtype: 1,
    //     bo_entity_registration_number: "",
    //     bo_entity_registered_name: "fsfsafsdfdsf",
    //     bo_entity_botype: "3",
    //   },
    //   {
    //     bo_entity: 1738931462309,
    //     bo_entity_representatives: [
    //       {
    //         bo_entity_representative: 1738931470371,
    //         bo_entity_representative_sorted: false,
    //         bo_entity_representative_collapsed: false,
    //         bo_entity_representative_botype: 1,
    //         bo_entity_representative_idtype: "1",
    //         bo_entity_representative_taxtype: 1,
    //         bo_entity_representative_country: "ZAF",
    //         bo_entity_representative_mobilecode: "1684",
    //         bo_entity_representative_passportcountry: "ZAF",
    //         bo_entity_representative_placeofbirth: "ZAF",
    //         bo_entity_representative_taxjuristiction: "ZAF",
    //         bo_entity_representative_name: "Test",
    //         bo_entity_representative_surname: "TestSurname",
    //         bo_entity_representative_email: "Test.TestSurname@gmail.com",
    //         bo_entity_representative_streetname: "5 Test Street",
    //         bo_entity_representative_city: "PRETORIA",
    //         bo_entity_representative_postalcode: "0010",
    //         bo_entity_representative_taxnumber: "1327118830",
    //         bo_entity_representative_idnumber: "6311135058084",
    //         bo_entity_representative_mobile: "0725555555",
    //         bo_entity_representative_suburb: "PRETORIA",
    //       },
    //     ],
    //     bo_entity_type: "4",
    //     bo_entity_taxnumber: "1327118830",
    //     bo_entity_taxtype: 1,
    //     bo_entity_registration_number: "",
    //     bo_entity_registered_name: "fsfsafsdfdsf",
    //     bo_entity_botype: "2",
    //   },
    //   {
    //     bo_entity: 1738931431134,
    //     bo_entity_representatives: [
    //       {
    //         bo_entity_representative: 1738931441082,
    //         bo_entity_representative_sorted: false,
    //         bo_entity_representative_collapsed: false,
    //         bo_entity_representative_botype: 1,
    //         bo_entity_representative_idtype: "1",
    //         bo_entity_representative_taxtype: 1,
    //         bo_entity_representative_country: "ZAF",
    //         bo_entity_representative_mobilecode: "43",
    //         bo_entity_representative_passportcountry: "ZAF",
    //         bo_entity_representative_placeofbirth: "ZAF",
    //         bo_entity_representative_taxjuristiction: "ZAF",
    //         bo_entity_representative_name: "Test",
    //         bo_entity_representative_surname: "TestSurname",
    //         bo_entity_representative_email: "Test.TestSurname@gmail.com",
    //         bo_entity_representative_streetname: "5 Test Street",
    //         bo_entity_representative_city: "PRETORIA",
    //         bo_entity_representative_postalcode: "0010",
    //         bo_entity_representative_idnumber: "6311135058084",
    //         bo_entity_representative_taxnumber: "1327118830",
    //         bo_entity_representative_mobile: "0725555555",
    //         bo_entity_representative_suburb: "PRETORIA",
    //       },
    //     ],
    //     bo_entity_type: "4",
    //     bo_entity_taxnumber: "1327118830",
    //     bo_entity_taxtype: 1,
    //     bo_entity_registration_number: "",
    //     bo_entity_registered_name: "fsfsafsdfdsf",
    //     bo_entity_botype: "1",
    //   },
    // ],
    // idtype: 1,
    // taxtype: 1,
    // registeredName: "kkkkkkkkkkkkkkkkkkk",
    // trustType: 2,
    // mastersOffice: 4,
    // trustNumber: "Dalstrust001",
    // title: "Ms",
    // name: "Test",
    // surname: "TestSurname",
    // email: "Test.TestSurname@gmail.com",
    // mobile: "0725555555",
    // telephone: "0725555555",
    // taxnumber: "3565009846",
    // idnumber: "3407295023083",
    // requestorCapacity: "3",
  };

  const reduxFormState = useSelector(formState);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const prefilledState = useMemo(() => reduxFormState?.values ?? initV, []);

  return (
    <Form
      onSubmit={async () => {
        switch (wizardPage) {
          case 0: {
            if (trustType == 4) {
              setWizardPage(3); //Requestor Details
            } else {
              setWizardPage(wizardPage + 1);
            }
            break;
          }
          case 3: {
            await dispatch(submitFormAsync());
            break;
          }
          default: {
            setWizardPage(wizardPage + 1);
          }
        }
      }}
      initialValues={prefilledState}
      mutators={{ ...arrayMutators }}
    >
      {({ handleSubmit, submitting, form }) => (
        <>
          <Grid container spacing={2} direction="column">
            <FormSpy
              onChange={(state) => {
                dispatch(updateFormState(state));
              }}
            />
            <Wizard page={wizardPage} />

            <Grid size={{ xs: 12 }}>
              <Card>
                <CardContent>
                  <Grid
                    container
                    spacing={2}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                          if (wizardPage == 0) {
                            setConfirmClearModal(true);
                          } else {
                            if (trustType == 4 && wizardPage == 3) {
                              setWizardPage(0);
                            } else {
                              setWizardPage(wizardPage - 1);
                            }
                          }
                        }}
                      >
                        {wizardPage == 0 ? "Reset Form" : "Back"}
                      </Button>
                    </Grid>
                    <Grid>
                      {(config.ENVIRONMENT === "development" ||
                        config.ENVIRONMENT === "qadebug") &&
                      wizardPage == 3 ? (
                        <Button
                          id="continue-to-upload"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            dispatch(submitFormAsync());
                          }}
                          loading={submitting}
                        >
                          Next //no frontend validation
                        </Button>
                      ) : null}

                      {
                        <Button
                          id="continue-to-upload"
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                          loading={submitting}
                        >
                          Next
                        </Button>
                      }
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <ConfirmDangerModalComponent
            open={confirmClearModal}
            onClose={() => {
              setConfirmClearModal(false);
            }}
            cbConfirm={() => {
              form.restart(initV);
              setConfirmClearModal(false);
            }}
            title="Reset form"
            subheader="Are you sure you want to clear the form?"
            confirmText="Clear"
          />
          {window.REACT_APP_CONFIG.ENVIRONMENT === "development" ? (
            <pre>{JSON.stringify(form.getState(), null, 2)}</pre>
          ) : (
            <></>
          )}
        </>
      )}
    </Form>
  );
};

const Wizard = ({ page }) => {
  switch (page) {
    case 0: {
      return <TrustDetails />;
    }
    case 1: {
      return <TrustAdditionalDetailsIndividuals />;
    }
    case 2: {
      return <TrustAdditionalDetailsEntities />;
    }
    case 3: {
      return <RequestorDetails />;
    }
    default:
      return <></>;
  }
};

export default EnterDetails;
